import React from "react";
import MainSection from "../components/MainSection";
import ServicesContentContainer from "../components/ServicesContentContainer";

const Pd = () => {
  const contentData = [
    {
      id: 1,
      title: "Pre-Departure Briefing",
      description:
        "We conduct comprehensive pre-departure sessions covering various aspects such as cultural sensitivity, health and safety, travel planning, accommodation and student life in the new country.",
    },
    {
      id: 2,
      title: "Document Checklist",
      description:
        "We assist you in preparing a checklist of all important documents you will need for your journey and stay abroad. This ensures you are well-prepared and not missing any essential documents.",
    },
    {
      id: 3,
      title: "Accommodation Assistance",
      description:
        "We help you with the process of finding and securing comfortable and safe accommodation that fits within your budget and is close to your university.",
    },
    {
      id: 4,
      title: "Travel Arrangements",
      description:
        "As part of our services, we also offer travel assistance. We have a dedicated ticketing service that helps you find the most convenient and cost-effective travel options.",
    },
    {
      id: 5,
      title: "Local Transportation",
      description:
        "We guide you on the local transportation system of the city you'll be moving to, including information on public transport, taxi services, and car rentals.",
    },
    {
      id: 6,
      title: "Stay Connected",
      description:
        "We help you understand the process of getting a local SIM card and opening a bank account in your new city. These are essential to stay connected and manage your finances abroad.",
    },
  ];
  const conclusion =
    "Our team is here to ensure that your transition to your new life abroad is as smooth and worry-free as possible. We remain available to support you even after your departure.";
  return (
    <>
      <MainSection
        bannerTxt="PRE-DEPARTURE & DEPARTURE GUIDANCE"
        color="gray"
      />
      <ServicesContentContainer
        contentData={contentData}
        conclusion={conclusion}
        title={"Pre-Departure & Departure Guidance"}
        includeTxt={"Processes"}
      />
    </>
  );
};

export default Pd;
